/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "HarishGouda G Patil",
  title: "Hi all, I'm Harish",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 having an experience of building Web and Mobile applications with JavaScript / Reactjs / Nodejs / React Native and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1m6ytuXV56031-osPmv-7vNuDHl9fNePz/preview", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/Harishgouda06022004/",
  linkedin: "https://www.linkedin.com/in/harish-patil-283819258/",
  gmail: "harishgouda213@gmail.com",
  medium: "https://medium.com/@harishgouda216",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    // {
    //   skillName: "swift",
    //   fontAwesomeClassname: "fab fa-swift"
    // },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    // {
    //   skillName: "firebase",
    //   fontAwesomeClassname: "fas fa-fir"
    // },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Visvesvaraya Technological University",
      logo: require("./assets/images/vtu.jpeg"),
      subHeader: "Bachelor of Science in Computer Science CGPA:9.0",
      duration: "December 2022 - December 2026"
      // desc: "Participated in the research of XXX and published 3 papers.",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      schoolName: "Vidyaniketan P.U. Science College",
      logo: require("./assets/images/vidyniketan.jpeg"),
      subHeader: "Science Percentage-84%",
      duration: "October 2020 - October 2022"
      // desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
      // descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    },
    {
      schoolName: "Shanti Niketan English Medium School Hubli",
      logo: require("./assets/images/school.jpeg"),
      subHeader: "School 10th Percentage 94%",
      duration: "October 2008 - October 2020"
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Gravity India Technologies Pvt Ltd",
      companylogo: require("./assets/images/gravityindialogo.png"),
      date: "Jun 2025 – Sep 2025",
      desc: "Software Engineer building AI-powered products and full stack web applications end to end — from data pipelines to production UI. Bengaluru, Karnataka (On-site).",
      descBullets: [
        "Built AI-driven features using Python, LangChain and RAG pipelines to automate manual workflows",
        "Developed responsive React.js interfaces backed by REST APIs and SQL databases",
        "Collaborated in an Agile team on code reviews, testing and on-time feature delivery"
      ]
    },
    {
      role: "Software Engineer",
      company: "HSN Software Technologies Pvt Ltd",
      companylogo: require("./assets/images/hsn-logo.png"),
      date: "Nov 2025 – Jun 2026",
      desc: "Software Engineer delivering scalable full stack applications and intelligent, LLM-powered features for real business use cases. Bengaluru, Karnataka (On-site).",
      descBullets: [
        "Engineered full stack modules with React.js, Node.js and Python for high-traffic applications",
        "Designed and integrated secure REST APIs with optimized SQL queries for faster response times",
        "Shipped AI assistant features leveraging LLMs and RAG to improve user productivity"
      ]
    },
    {
      role: "Software Engineer",
      company: "EldersIndia",
      companylogo: require("./assets/images/EldersIndia-Logo.png"),
      date: "July 2026 – present",
      desc: "Software Engineer driving the design and development of AI-powered, production-grade full stack platforms from concept to deployment.",
      descBullets: [
        "Building end-to-end features with React.js, Next.js, Node.js and Python",
        "Architecting AI Agents and RAG pipelines with LangChain for smarter, context-aware products",
        "Owning API design, SQL data modeling and performance tuning across the stack"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at .md */

const openSource = {
  showGithubProfile: true, // Set true or false to show Contact profile using Github, defaults to true
  display: true, // Set false to hide this section, defaults to true
  contributions: [
    {
      title: "Care OHC Network",
      description:
        "Contributed to the front-end of the Care OHC Network platform.",
      prLink: "https://github.com/ohcnetwork/care_fe/pull/11869"
    }
  ]
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/xirr.png"),
      projectName: "XIRR",
      projectDesc:
        "A platform to streamline startup investment tracking and financial analytics for founders",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://thexirr.com/"
        }
        //  you can add extra buttons here.
      ]
    }
    // {
    //   image: require("./assets/images/autocrud.png"),
    //   projectName: "Auto-Crud",
    //   projectDesc:
    //     "A tool that auto-generates full CRUD operations for Laravel projects with minimal setup.",
    //   footerLink: [
    //     {
    //       name: "Visit Website",
    //       url: "https://app.autocrud.com"
    //     }
    //   ]
    // },
    // {
    //   image: require("./assets/images/courseapp.png"),
    //   projectName: "Courseapp",
    //   projectDesc:
    //     "This will help users to buy courses related to programming languages",
    //   footerLink: [
    //     {
    //       name: "Visit Website",
    //       url: "https://course-application-32.vercel.app/"
    //     }
    //   ]
    // }
  ],
  display: true // Set false to hide this section, defaults to true
};

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "LeetCode 50 days badage",
      subtitle: "First 50 days badage",
      image: require("./assets/images/leetcode.jpeg"),
      imageAlt: "LeetCode Logo",
      footerLink: [
        // {
        //   name: "Certification",
        //   url: "https://leetcode.com/medal/?showImg=0&id=6276283&isLevel=false"
        // },
        {
          name: "LeetCode 50 days badage",
          url: "https://leetcode.com/medal/?showImg=0&id=6276283&isLevel=false"
        }
        // {
        //   name: "Google Code-in Blog",
        //   url: "https://.googleblog.com/2019/01/google-code-in-2018-winners.html"
        // }
      ]
    },
    {
      title: "LeetCode 100 days badage",
      subtitle: "Consistent for 100 days on leetcode platform",
      image: require("./assets/images/leetcode.jpeg"),
      imageAlt: "LeetCode logo",
      footerLink: [
        {
          name: "leetCode 100 days badage",
          url: "https://leetcode.com/medal/?showImg=0&id=6810406&isLevel=false"
        }
      ]
    },

    {
      title: "LeetCode sql 50 badage",
      subtitle: "LeetCode sql 50 badage",
      image: require("./assets/images/leetcode.jpeg"),
      imageAlt: "Sql 50 Logo",
      footerLink: [
        // {name: "Certification", url: ""},
        {
          name: "Sql 50 leetCode",
          url: "https://leetcode.com/medal/?showImg=0&id=6700833&isLevel=false"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://medium.com/@harishgouda216/artic-le-2-f1baea32bf62",
      title: "Basic Linux Commands which every developer should know",
      description:
        "A beginner-friendly guide that introduces essential Linux commands every developer should know to navigate, manage files, and boost productivity in a terminal environment."
    },
    {
      url: "https://medium.com/@harishgouda216/article-1-97159c527652",
      title: "Linux The Beautiful Art",
      description:
        "An insightful article that explores the elegance and power of Linux, highlighting its versatility, open-source nature, and why it's cherished by developers around the world."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Fabric Defect Detection",
      subtitle: "A model which will detect the Defects in the Fabric",
      slides_url:
        "https://docs.google.com/presentation/d/1GqWaGWi_0pYlocAEOiXElhQiRXyZlE1E/edit?usp=sharing&ouid=105445719629067261950&rtpof=true&sd=true",
      event_url: ""
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Personal Projects Section
const personalProjects = {
  title: "Personal Projects",
  subtitle:
    "Some cool personal projects I’ve built to learn and explore new technologies.",
  projects: [
    {
      image: require("./assets/images/smartdocbot.png"), // Add your image to assets/images
      projectName: "SmartDocBot",
      projectDesc:
        "A chatbot that scans the pdf and provides preview where user can ask questions related to that pdf.",
      footerLink: [
        // {
        //   name: "Visit Website",
        //   url: "https://yourprojecturl.com"
        // },
        {
          name: "Source Code",
          url: "https://github.com/Harishgouda06022004/smartdocbot"
        }
      ]
    },
    {
      image: require("./assets/images/courseapp.png"),
      projectName: "CourseApplication",
      projectDesc:
        "A simple Course Application which will help users to buy the courses related to Programming language. previes can be viewed on github",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://course-application-32.vercel.app/"
        },
        {
          name: "Source Code",
          url: "https://github.com/Harishgouda06022004/courseapplication"
        }
      ]
    },
    {
      image: require("./assets/images/webscrape.png"),
      projectName: "WebScraping",
      projectDesc: "A simple scrap to scrap related to the hospital websites",
      footerLink: [
        // {
        //     name: "Visit Website",
        //     url: "https://course-application-32.vercel.app/"
        // },
        {
          name: "Source Code",
          url: "https://github.com/Harishgouda06022004/Webscraping"
        }
      ]
    },
    {
      image: require("./assets/images/joke.png"),
      projectName: "JokeApp",
      projectDesc:
        "A random joke generator which will gernate 10 jokes to make you laugh",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://harishgouda06022004.github.io/jokeApp/"
        },
        {
          name: "Source Code",
          url: "https://github.com/Harishgouda06022004/jokeApp"
        }
      ]
    },
    {
      image: require("./assets/images/gobookstore.png"),
      projectName: "Go-BookStore",
      projectDesc:
        "go-bookstore 📚 is a simple and powerful RESTful API built with Go (Golang) for managing a bookstore's inventory. It supports CRUD operations for books, clean architecture, and easy integration ",
      footerLink: [
        // {
        //     name: "Visit Website",
        //     url: "https://harishgouda06022004.github.io/jokeApp/"
        // },
        {
          name: "Source Code",
          url: "https://github.com/Harishgouda06022004/go-bookstore"
        }
      ]
    },
    {
      image: require("./assets/images/weather.png"),
      projectName: "Weather-App",
      projectDesc:
        "A simple weather app which will give the data of weather of diffrent countries across world",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://harishgouda06022004.github.io/WeatherApp/"
        },
        {
          name: "Source Code",
          url: "https://github.com/Harishgouda06022004/WeatherApp"
        }
      ]
    },
    {
      image: require("./assets/images/chessengine.png"),
      projectName: "Chess Moves simple game",
      projectDesc:
        "A simple moves chess app is likely focused on providing a user-friendly experience, particularly for beginners, by emphasizing clear and straightforward gameplay with easy-to-understand moves for each piece",
      footerLink: [
        // {
        //     name: "Visit Website",
        //     url: "https://harishgouda06022004.github.io/WeatherApp/"
        // },
        {
          name: "Source Code",
          url: "https://github.com/Harishgouda06022004/CHESS-ENGINE"
        }
      ]
    }
  ],
  display: true // Set false to hide this section
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91 8867355035",
  email_address: "Harishgouda213@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  personalProjects,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
